import React, { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
const {Title} = Typography;

const ConfirmDeletePatientModal = ({open, setOpen, handleDeletePatient, loading}) => {


  const handleOk = async() => {
    await handleDeletePatient();
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal
        open={open}
        title="Confirm Delete Patient Entry"
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        maskClosable={false}
        destroyOnClose
        footer={[
          <Button type="primary" key="back" onClick={handleCancel} danger>
            No
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
            Yes
          </Button>
        ]}
      >
        <Title level={5} style={{padding: "10px"}}>Are you sure you want to delete the patient entry?</Title>
      </Modal>
    </>
  );
};

export default ConfirmDeletePatientModal;